import React, { Component } from "react";
import { connect } from "react-redux";
import { func, arrayOf, shape, string, bool, element } from "prop-types";
import CampaignList from "pages/campaigns/CampaignList";

import { selectors, actions } from "reducers/campaigns";

class Campaigns extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        section: string.isRequired,
        items: arrayOf(
            shape({
                image: string,
                idCampaign: string,
                url: string,
                clickable: bool,
            }),
        ).isRequired,
        container: element,
        draggableItemProps: shape({}).isRequired,
    };

    static defaultProps = {
        container: null,
    };

    componentDidMount() {
        const { dispatch, section } = this.props;
        dispatch(actions.listCampaignsBySection(section));
    }

    render() {
        const { items, draggableItemProps } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetAccounts" };

        if (items.length === 0) {
            return null;
        }

        return (
            <CampaignList {...this.props}>
                {(list) => (
                    <section className="widget accounts" {...uiAutomationProp} {...draggableItemProps}>
                        {list}
                        <div className="overlay" />
                    </section>
                )}
            </CampaignList>
        );
    }
}

const mapStateToProps = (state) => ({
    items: selectors.getCampaigns(state),
});

export default connect(mapStateToProps)(Campaigns);
